import { Add, GroupAdd } from '@mui/icons-material'
import { Card, Grid } from '@mui/material'
import CustomTitle from 'components/shared/CustomTitle'
import CustomDialog from 'components/shared/Dialog/CustomDialog'
import MyTable from 'components/shared/Tables/MyTable/MyTable'
import MyTableToolbar from 'components/shared/Tables/MyTable/MyTableToolbar'
import { handleDownloadCsv, handlePrintCsv } from 'components/utils/handlers'
import { useEffect, useMemo, useState } from 'react'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { employeesActions } from '../../../../../redux/slice/employees.slice'
import { DELETE_EMPLOYEES, GET_EMPLOYEES } from '../../../../../redux/types/employee.types'
import { EMPLOYEE_DOWNLOAD_COLS, employeeColumns } from '../helper'
import OrgGroupSelector from '../OrgGroupSelector'
import EmployeeForm from './EmployeeForm'
import { orgGroupsActions } from '../../../../../redux/slice/orgGroups.slice'
import { ASSIGN_EMPLOYEE } from '../../../../../redux/types/organization.types'
import { authActions } from '../../../../../redux/slice/auth.slice'
import { accessActions } from '../../../../../redux/slice/access.slice'
import { checkSinglePermission } from 'components/shared/helper'
import { USER_PERMISSIONS } from '../../AccessManagement/helper'

const Employees = () => {
    const [employeeSearchTerm, setEmployeeSearchTerm] = useState("");
    const orgGroups = useSelector(orgGroupsActions.selectors.getOrgGroups)
    const dispatch = useDispatch()
    useEffect(() => {

        dispatch({ type: GET_EMPLOYEES })
    }, [dispatch])

    const employees = useSelector(employeesActions.selectors.getEmployees);
    const currentUser = useSelector(authActions.selectors.getCurrentUser);
    const userPermissions = useSelector(accessActions.selectors.getUserPermissions)


    const handleEmployeeSearch = (term) => {
        setEmployeeSearchTerm(term);
    };

    const filteredEmployees = useMemo(() => {
        if (!employeeSearchTerm) return employees;
        const regex = new RegExp(employeeSearchTerm, "i");
        return employees.filter((pkg) =>
            Object.values(pkg).some((value) => regex.test(value))
        );
    }, [employeeSearchTerm, employees]);

    const [isEmployeeOpen, setIsEmployeeOpen] = useState(false);
    const handleEmployeeOpen = () => {
        setIsEmployeeOpen(true)
    }
    const handleIsEmployeeClose = () => {
        setIsEmployeeOpen(false)
    }

    const [selectedEmployees, setSelectedEmployees] = useState([])
    const handleSelectedRows = (ids) => {
        setSelectedEmployees(ids);
    }

    const handleDeleteEmployees = () => {
        if (!selectedEmployees?.length) {
            return toast.error("Please Select Employees to delete")
        }
        dispatch({ type: DELETE_EMPLOYEES, payload: { ids: selectedEmployees } })
    }



    const [selectedGroup, setSelectedGroup] = useState({})
    const [openGroup, setOpenGroup] = useState(false);
    const handleGroupOpen = () => {
        setOpenGroup(true)
    }
    const handleGroupClose = () => {
        setOpenGroup(false)
    }

    const handleAddEmployee = () => {
        if (!selectedEmployees?.length) {
            toast.error("Please Select the Employees First");
            return
        }
        handleGroupOpen()
    }

    const handleAddToGroup = () => {
        const payload = {
            empIds: selectedEmployees,
            groupId: selectedGroup
        }
        dispatch({ type: ASSIGN_EMPLOYEE, payload });
        handleGroupClose();
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <CustomTitle title={"Employees"} count={filteredEmployees?.length} />
                    <br />
                    <Card>
                        <MyTableToolbar
                            placeHolder={"Search Employees"}
                            btn2Txt={checkSinglePermission(USER_PERMISSIONS.ADD_EMPLOYEES, userPermissions, currentUser?.role) ? "Add Employee" : null}
                            btn1Txt={checkSinglePermission(USER_PERMISSIONS.ASSIGN_EMPLOYEES_TO_GROUP, userPermissions, currentUser?.role) ? "Assign Employee to Group" : null}
                            btn1Icon={GroupAdd}
                            btn2Icon={Add}
                            handleBtn1Click={handleAddEmployee}
                            handleBtn2Click={handleEmployeeOpen}
                            onSearch={handleEmployeeSearch}
                            onDownload={() => handleDownloadCsv({ rows: filteredEmployees, columns: EMPLOYEE_DOWNLOAD_COLS, name: "employees" })}
                            onPrint={() => handlePrintCsv({ rows: filteredEmployees, columns: EMPLOYEE_DOWNLOAD_COLS, name: "employees" })}
                            isUninstall={checkSinglePermission(USER_PERMISSIONS.DELETE_EMPLOYEES, userPermissions, currentUser?.role)}
                            handleDeleteClick={handleDeleteEmployees}
                        />
                        <MyTable
                            checkboxSelection={true}
                            columns={employeeColumns}
                            rows={filteredEmployees}
                            id={(row) => row?._id}
                            handleSelectedRows={handleSelectedRows}
                        />
                    </Card>
                </Grid>



            </Grid>
            <br />
            <CustomDialog title={'Add Employee'} isOpen={isEmployeeOpen} handleToggle={handleIsEmployeeClose} maxWidth={"md"}>
                <EmployeeForm handleIsEmployeeClose={handleIsEmployeeClose} />
            </CustomDialog>

            <CustomDialog title="Select Group" isOpen={openGroup} handleToggle={handleGroupClose} maxWidth={"md"}>
                <OrgGroupSelector groups={orgGroups} handleAddToGroup={handleAddToGroup} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} handleClose={handleGroupClose} />
            </CustomDialog>
        </>
    )
}

export default Employees
